const initialState = {
  groups: [],
  layer: null,
  sldEditors: {},
  sldTitle: null,
  sldId: null,
  sldEditorActiveTab: null,
};

export default function sldEditorReducer(state = initialState, action) {
  switch (action.type) {
    case "loadconfiguration":
      {
        return {
          groups: [],
          layer: null,
          sldEditors: {},
          sldTitle: null,
          sldId: null,
          sldEditorActiveTab: null,
        };
      }
      break;

    case "sldEditor/add":
      {
        let newState = { ...state };

        newState.groups = [...state.groups, action.payload];

        newState.sldEditorActiveTab = "sldEditor".concat(
          newState.groups.length - 1
        );

        return { ...newState };
      }
      break;

    case "sldEditor/editors/add":
      {
        let newState = { ...state };

        if (!newState.sldEditors[action.payload.id]) {
          newState.sldEditors[action.payload.id] = {};
        }

        newState.sldEditors[action.payload.id][action.payload.sldId] = {
          groups: action.payload.groups,
          title: action.payload.title,
        };

        return { ...newState };
      }
      break;

    case "sldEditor/groups/delete":
      {
        let newState = { ...state };

        newState.groups.splice(action.payload, 1);

        if (newState.groups.length < 0) {
          newState.sldEditorActiveTab = null;
        } else {
          newState.sldEditorActiveTab = "sldEditor".concat(
            newState.groups.length - 1
          );
        }

        return { ...newState };
      }
      break;

    case "sldEditor/title/update":
      {
        let newState = { ...state };

        newState.sldTitle = action.payload;

        return { ...newState };
      }
      break;

    case "sldEditor/sldEditorActiveTab":
      {
        {
          let newState = { ...state };

          newState.sldEditorActiveTab = action.payload;

          return { ...newState };
        }
      }
      break;

    case "sldEditor/layer/update":
      {
        let newState = { ...state };

        newState.layer = action.payload.layer;
        newState.groups = [];
        newState.sldTitle = null;
        newState.sldId = action.payload.sldId;

        return { ...newState };
      }
      break;

    case "sldEditor/layer/delete":
      {
        let newState = { ...state };

        if (newState.sldEditors[action.payload.id]) {
          delete newState.sldEditors[action.payload.id];
        }

        return { ...newState };
      }
      break;

    case "sldEditor/update":
      {
        let newState = { ...state };

        newState.layer = action.payload.id;
        newState.groups = action.payload.groups;

        return { ...newState };
      }
      break;

    case "sldEditor/group/rule/update":
      {
        let newState = { ...state };

        newState.groups[action.payload.groupIndex][0][action.payload.property] =
          action.payload.value;

        return { ...newState };
      }
      break;

    case "sldEditor/group/update":
      {
        let newState = { ...state };

        newState.groups[action.payload.groupIndex][action.payload.property] =
          action.payload.value;

        return { ...newState };
      }
      break;

    case "sldEditor/criteria/add":
      {
        let newState = { ...state };

        newState.groups[action.payload.groupIndex] = [
          ...newState.groups[action.payload.groupIndex],
          action.payload.criteria,
        ];

        return { ...newState };
      }
      break;

    case "sldEditor/criteria/delete":
      {
        let newState = { ...state };

        newState.groups[action.payload.groupIndex].splice(
          action.payload.criteriaIndex,
          1
        );

        return { ...newState };
      }
      break;

    case "sldEditor/criteria/update":
      {
        let newState = { ...state };

        newState.groups[action.payload.groupIndex][
          action.payload.criteriaIndex
        ][action.payload.property] = action.payload.value;

        return { ...newState };
      }
      break;

    case "sldEditor/layer/add":
      {
        let newState = { ...state };

        if (!newState.sldEditors[action.payload.id]) {
          newState.sldEditors[action.payload.id] = {
            cqlFilter: null,
            cqlFilterObject: null,
            groups: null,
          };
        }
        newState.sldEditors[action.payload.id] = {
          cqlFilter: action.payload.cqlFilter,
          cqlFilterObject: action.payload.cqlFilterObject,
          groups: action.payload.groups,
        };

        return { ...newState };
      }
      break;

    case "sldEditor/layer/delete":
      {
        let newState = { ...state };

        if (newState.sldEditors[action.payload.id]) {
          delete newState.sldEditors[action.payload.id];
        }

        return { ...newState };
      }
      break;

    default:
      return state;
  }
}
